/* global $ */

export function initKeySearch() {
  let timer
  let startTimer = () => {
    timer = setInterval(() => {
      if ($('#gsc-i-id1').val() !== undefined) {
        startSearch()
        clearInterval(timer)
      }
    }, 100)
  }
  startTimer()
  let startSearch = () => {
    $('#gsc-i-id1').val((new URL(window.location)).searchParams.get('query'));
    $('.gsc-search-button > button').trigger('click')
  }
}